<template>
  <form action="" method="post" @preventclass="data - container" @keypress.enter.prevent>
    <div class="data-container__block">
      <p class="dea-text--left dea-text--no-margin" :class="titleClass">Codice Fiscale</p>
      <div class="dea-heading--medium__xm data-container__info">
        <InputText
          id="fiscalCode"
          type="text"
          :placeholder="fiscalCodePlaceholder"
          :state="state"
          :message="message"
          :icon="icon"
          :value="fiscalCode"
          :fis="fiscalCodeError"
          :is-disabled="isDisabled"
          @keyup="checkFiscalCode($event)"
        ></InputText>
      </div>
    </div>
    <div v-if="showCheckbox" class="data-container__block">
      <Checkbox id="not-fc" name="not-fc" class="checkbox-fc" @change="$emit('change-checkbox', $event.target.checked)">
        Preferisco non fornire il mio codice fiscale: non mi interessa inserire questo corso all'interno delle
        iniziative formative nella piattaforma ministeriale S.O.F.I.A. Per me, è sufficiente l'attestato di
        partecipazione rilasciato da Deascuola Formazione.
      </Checkbox>
    </div>
  </form>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import Checkbox from "@/components/elements/Checkbox";
import InputText from "@/components/elements/InputText";

export default {
  name: "FiscalCodeConfirmation",
  components: {
    Checkbox,
    InputText,
  },
  props: {
    fiscalCodePlaceholder: {
      type: String,
      default: "",
    },
    titleClass: {
      type: String,
      default: "dea-heading--medium__m",
    },
    isDisabled: {
      type: String,
      default: "false",
    },
    showCheckbox: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showFcError: false,
    };
  },
  computed: {
    state() {
      return this.showFcError || this.fiscalCodeError ? "error" : "";
    },
    icon() {
      return this.showFcError || this.fiscalCodeError ? "error" : "";
    },
    message() {
      return this.showFcError || this.fiscalCodeError
        ? "Codice fiscale non corretto. Verifica l'esattezza dei dati"
        : "";
    },
    ...mapGetters(["user", "fiscalCode", "fiscalCodeError", "isFCWrong"]),
  },
  methods: {
    ...mapActions(["setLocalFiscalCode"]),
    ...mapMutations(["setFCCheck"]),
    checkFiscalCode(event) {
      const newFiscalCode = event.target.value;
      if (newFiscalCode.length === 16) {
        // newFiscalCode = document.getElementById("fiscalCode").value;
        const patt = /^(?:(?:[B-DF-HJ-NP-TV-Z]|[AEIOU])[AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[1256LMRS][\dLMNP-V])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i;

        if (patt.test(newFiscalCode)) {
          this.showFcError = !this.checkFiscalCodeChecksum(newFiscalCode.toUpperCase());
        } else {
          this.showFcError = true;
        }
      }
      this.setFCCheck(this.showFcError);
      this.setLocalFiscalCode(newFiscalCode);
      // Fiscal Code can be updated by calling this.updateCode('teas')
    },
    checkFiscalCodeChecksum(cf) {
      const set1 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const set2 = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const setpari = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const setdisp = "BAKPLCQDREVOSFTGUHMINJWZYX";
      let s = 0;
      for (let i = 1; i <= 13; i += 2) s += setpari.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
      for (let i = 0; i <= 14; i += 2) s += setdisp.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
      return s % 26 === cf.charCodeAt(15) - "A".charCodeAt(0);
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.dea-text--no-margin {
  margin: 0;
}

.data-container__info {
  display: block;
}
</style>
